import { useQuery } from '@tanstack/react-query';
import { buscarEquipamentosDoColaborador } from '../../services';

/**
 * Equipamentos hoje vinculados a um colaborador — usado ao abrir Mudança de Projeto/
 * Troca de Equipamento, pra sugerir automaticamente qual devolver (ver
 * NovaSolicitacaoContent, onMovimentacaoWriteAplicarEquipamentoSugerido).
 */
export function useEquipamentosDoColaboradorQuery(colaboradorId: string | undefined) {
  return useQuery({
    queryKey: ['si', 'equipamentos-do-colaborador', colaboradorId],
    queryFn: () => buscarEquipamentosDoColaborador(colaboradorId as string),
    enabled: Boolean(colaboradorId),
  });
}
